import { useUser } from 'services/User';
import { useIntegration } from 'services/api/Integrations';
import { ServiceId } from 'hooks/useQueryFilter';

export const useApikey = ({ serviceId }: { serviceId?: ServiceId | string | null } = {}) => {
    const { user } = useUser();
    const { data: integration, isLoading } = useIntegration({ serviceId: (serviceId as ServiceId) || '' });
    const apikey = integration?.serviceApikey ?? user?.portal_api_key;

    if (isLoading) {
        return { apikey: null };
    }

    return { apikey };
};
